module.exports = __webpack_public_path__ + "img/rejected.92bf3f0c.svg";